import { useSingleOpenLinkPopover } from '@/atoms/link-popover-open';
import { useSidebarPanelOverlayLock } from '@/components/layout/Navigation/sidebar-panel/hooks/use-sidebar-panel-overlay-lock';
import {
  getSidebarPanelOverlayOpenProps,
  getSidebarPanelOverlayTriggerProps,
} from '@/components/layout/Navigation/sidebar-panel/sidebar-overlay-constants';
import LinkSessionsToPatientModal from '@/components/modal/LinkSessionsToNewPatientModal';
import {
  IS_CONSOLIDATED_SESSIONS_LIST_ENABLED,
  IS_SIDEBAR_PANEL_ENABLED,
} from '@/features/flags';
import { type SessionListLinkPopoverHost } from '@heidi/patients';

import { useSessionListLinkController } from './hooks/useSessionListLinkController';
import { usePatientSearchComboboxHost } from './usePatientSearchComboboxHost';

/** Binds the session-list link popover to the app overlay and create modal. */
export function useSessionListLinkPopoverHost(): SessionListLinkPopoverHost {
  const searchHost = usePatientSearchComboboxHost();

  return {
    useSessionListLinkController,
    useSingleOpenLinkPopover,
    useSidebarPanelOverlayLock,
    getSidebarPanelOverlayTriggerProps,
    getSidebarPanelOverlayOpenProps,
    LinkSessionsToPatientModal,
    isConsolidatedSessionsListEnabled: IS_CONSOLIDATED_SESSIONS_LIST_ENABLED,
    isSidebarPanelEnabled: IS_SIDEBAR_PANEL_ENABLED,
    searchHost,
  };
}
